import unlimitedOption from '../constants/unlimitedOption';

const getSuffixLabel = (
givenSuffixLabel,
value,
allowUnlimitedOption) =>

allowUnlimitedOption && value === unlimitedOption.value ?
`${unlimitedOption.label} ${givenSuffixLabel || ''}`.trim() :
givenSuffixLabel || '';


export default getSuffixLabel;